import type { Possession } from '../stores/possessionsStore';
import { POINTS } from './levelCalculation';

/**
 * Possessions economy XP (Ecological EC4) — a DERIVED view: tracking an asset is
 * worth a little, and each maintenance completion is worth more (upkeep is the
 * point). The SAME value credits the Ecological domain (useUserStats) and the
 * Possessions area rank (useDisciplines), so the domain is credited exactly once
 * and the area never re-mints. Pure + idempotent.
 */
export const POSSESSION_ASSET_XP = 10;
export const POSSESSION_MAINTENANCE_XP = 15;

export function computePossessionsEconomyXP(possessions: Possession[]): number {
  // Config-backed (console → XP economy); the consts above are the defaults.
  const assetXP = POINTS.ECO_POSSESSION_ASSET ?? POSSESSION_ASSET_XP;
  const maintenanceXP = POINTS.ECO_POSSESSION_MAINTENANCE ?? POSSESSION_MAINTENANCE_XP;
  let xp = possessions.length * assetXP;
  for (const p of possessions) {
    for (const m of p.maintenance) {
      xp += Math.max(0, m.completionCount || 0) * maintenanceXP;
    }
  }
  return xp;
}
